'use client';

import { Label, Select } from 'components';
import { i18n } from 'i18n-config';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { useClientAccountUpdate } from 'providers/UserProvider/useClientAccountUpdate';
import { useCurrentUser } from 'providers/UserProvider/useCurrentUser';
import { Option } from 'types/Option';
import { delay } from 'utils/delay';
import { setPersistedLocale } from 'utils/setPersistedLocale';

const LanguagePage = () => {
  const t = useTranslations();
  const router = useRouter();
  const { data, refetch, isFetchedAfterMount } = useCurrentUser();
  const { mutateAsync } = useClientAccountUpdate();

  const selectedLanguage = i18n.locales.find((locale) => locale === data?.locale);

  const handlerUpdateLocale = ({ value }: Option) => {
    const locale = value as string;

    if (data?.emailPreferences)
      mutateAsync({
        firstName: String(data?.firstName),
        lastName: String(data?.lastName),
        locale,
        timeZone: String(data?.timeZone),
        emailNotifications: data?.emailPreferences
      }).then(async () => {
        if (isFetchedAfterMount) setPersistedLocale(locale);
        await refetch();
        await delay(2000);
        router.push('/account-details');
      });
  };

  return (
    <div className="w-full">
      <Label>{t('account_details.index.locale')}</Label>
      <Select
        id="locale"
        onChange={handlerUpdateLocale}
        selectedValue={selectedLanguage}
        options={i18n.locales.map((locale) => ({
          value: locale,
          label: t(`languages.${locale}` as any)
        }))}
      />
    </div>
  );
};

export default LanguagePage;
